<div class="tab-content">
  <div class="container-fluid px-0">
    <div class="row stockouts-row">
      <div class="col-md-6 stockouts-col">
        <div class="data-card stockout-table">
          <h3>Stock-out Risk & Days-of-Supply</h3>
          <div class="table-container">
            <div *ngIf="isLoadingStockoutRisk" class="loading-overlay">
              <div class="spinner-dots">
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
              </div>
            </div>
            <div *ngIf="!isLoadingStockoutRisk && hasNoData()" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">table_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No stockout risk data found for the selected filters</p>
            </div>
            <table class="data-table" *ngIf="!isLoadingStockoutRisk && !hasNoData() && stockoutRows.length > 0">
              <thead>
                <tr>
                  <th>Machine</th>
                  <th>Product</th>
                  <th class="text-right">Inventory (lbs)</th>
                  <th class="text-right">Days Until Empty</th>
                  <th class="text-center">Risk</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of stockoutRows">
                  <td>{{ row.machine }}</td>
                  <td>{{ row.product }}</td>
                  <td class="text-right">{{ row.inventory }}</td>
                  <td class="text-right">{{ row.daysLeft }}</td>
                  <td class="text-center">
                    <span class="risk-indicator" [ngClass]="row.risk"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-md-6 stockouts-col">
        <!-- Machine Stock-out Risk Heatmap -->
        <div class="chart-card heatmap-card">
          <h3>Machine Stock-out Risk Heatmap</h3>
          <div class="heatmap-container">
            <div *ngIf="isLoadingStockoutHeatmap" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingStockoutHeatmap && hasNoHeatmapData()" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">insert_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No heatmap data found for the selected filters</p>
            </div>
            <div class="heatmap-grid" *ngIf="!isLoadingStockoutHeatmap && !hasNoHeatmapData()">
              <div
                *ngFor="let item of machineHeatmap"
                class="heatmap-item"
                [ngClass]="{
                  'risk-low': item.risk === 'low',
                  'risk-medium': item.risk === 'medium',
                  'risk-high': item.risk === 'high',
                  'active': filters.machines.includes(item.machine)
                }"
                [title]="item.machine + ' - ' + item.product + ': ' + item.minDays + ' days left'"
                (click)="toggleMachineFilter(item.machine)">
                <div class="heatmap-machine">{{ item.machine }}</div>
                <span class="heatmap-days">{{ item.minDays }}d</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

